// Every date the app shows is DD-Mon-YYYY. Stored and API formats stay ISO.
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const DOW = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

export const isoToday = () => new Date(Date.now() + 330 * 60000).toISOString().slice(0, 10);

/** "2026-09-26" → "26-Sep-2026". Anything unparseable comes back untouched. */
export const fmtDate = (iso) => {
  if (!iso) return "—";
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso));
  return m ? `${m[3]}-${MONTHS[Number(m[2]) - 1]}-${m[1]}` : String(iso);
};

/** "26-Sep" — for a grid header where the year is already above it. */
export const fmtDayMon = (iso) => {
  if (!iso) return "—";
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso));
  return m ? `${m[3]}-${MONTHS[Number(m[2]) - 1]}` : String(iso);
};

export const fmtDow = (iso, short = false) => {
  if (!iso) return "";
  const d = new Date(`${String(iso).slice(0, 10)}T00:00:00`);
  const name = DOW[d.getDay()] || "";
  return short ? name.slice(0, 3) : name;
};

/** "2026-09" → "September 2026". */
export const fmtMonth = (m) => {
  if (!m) return "—";
  const [y, mo] = String(m).split("-").map(Number);
  const full = ["January", "February", "March", "April", "May", "June", "July", "August",
    "September", "October", "November", "December"];
  return full[mo - 1] ? `${full[mo - 1]} ${y}` : String(m);
};

/** "3:54 pm" out of an ISO timestamp, read straight off the string so the wall clock it was
 *  stamped with is the wall clock shown — a browser in another zone cannot shift it. */
export const fmtTime = (iso) => {
  const m = /T(\d{2}):(\d{2})/.exec(String(iso || ""));
  if (!m) return "";
  const h = Number(m[1]);
  return `${((h + 11) % 12) + 1}:${m[2]} ${h < 12 ? "am" : "pm"}`;
};

/** A timestamp: "26-Sep-2026, 3:54 pm". */
export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  const s = String(iso);
  const d = new Date(s.endsWith("Z") || s.includes("+") ? s : `${s}Z`);
  if (Number.isNaN(d.getTime())) return "—";
  const day = String(d.getDate()).padStart(2, "0");
  const time = d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" }).toLowerCase();
  return `${day}-${MONTHS[d.getMonth()]}-${d.getFullYear()}, ${time}`;
};
